// src/pages/LoanStatus.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { initializeApp, getApps } from "firebase/app";
import {
  getFirestore,
  doc,
  onSnapshot,
  setDoc,
} from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";

// 🔹 Firebase Config
const firebaseConfig = {
  apiKey: "AIzaSyBSR0HllH8zLhaD962i61DsCnLdgsaCQtI",
  authDomain: "loanpulse-60d48.firebaseapp.com",
  projectId: "loanpulse-60d48",
  storageBucket: "loanpulse-60d48.firebasestorage.app",
  messagingSenderId: "447529471754",
  appId: "1:447529471754:web:6cb19f6ca2c3830357b4f3",
  measurementId: "G-HPWPBG2R0S"
};

// ✅ Prevent multiple initializations
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const db = getFirestore(app);
const messaging = getMessaging(app);

function LoanStatus() {
  const { id } = useParams(); // loanId from URL
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Request Notification Permission + Save Token
  const requestPermissionAndSaveToken = async () => {
    try {
      console.log("Requesting notification permission...");
      const permission = await Notification.requestPermission();
      console.log("Permission result:", permission);

      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY, // 🔑 Replace with your actual Web Push Key
        });

        if (token) {
          console.log("✅ Got FCM Token:", token);

          await setDoc(
            doc(db, "publicLoanLinks", id),
            {
              customerFCMtoken: token,
              updatedAt: new Date(),
            },
            { merge: true } // 🔹 Prevents overwriting other fields
          );

          console.log("✅ Token saved in Firestore under publicLoanLinks/" + id);
        }
      } else {
        console.log("❌ Notification permission denied");
      }
    } catch (err) {
      console.error("🔥 Error requesting notification permission:", err);
    }
  };

  // 🔹 Subscribe to Firestore updates
  useEffect(() => {
    setLoading(true); // reset loading on refresh

    const docRef = doc(db, "publicLoanLinks", id);
    const unsubscribe = onSnapshot(
      docRef,
      (snapshot) => {
        if (snapshot.exists()) {
          setData(snapshot.data());
        } else {
          setData({ error: "Loan record not found" });
        }
        setLoading(false); // stop loading only after snapshot returns
      },
      (err) => {
        console.error("Error fetching loan status:", err);
        setData({ error: "Error fetching loan status" });
        setLoading(false);
      }
    );

    // Request permission only once when page loads
    requestPermissionAndSaveToken();

    return () => unsubscribe();
  }, [id]);

  // 🔹 UI Rendering
  if (loading)
    return <p style={{ textAlign: "center" }}>Fetching loan status...</p>;

  if (data?.error)
    return (
      <p style={{ textAlign: "center", color: "red" }}>{data.error}</p>
    );

  return (
    <>
    <div style={styles.card}>
      <h2 style={{ color: "#663399" }}>Loan Application Status</h2>
      <p>
        <strong>Name:</strong> {data?.name}
      </p>
      <p>
        <strong>Phone:</strong> {data?.phone}
      </p>
      <p>
        <strong>Loan Type:</strong> {data?.loanType}
      </p>
      <p>
        <strong>Status:</strong> {data?.loanStage}
      </p>
      <p>
        <strong>Remarks:</strong> {data?.remarks || "—"}
      </p>
    </div>
    <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-center">
    <a href="/">Home</a>
    </div>
    </>
  );
}

const styles = {
  card: {
    maxWidth: 500,
    margin: "50px auto",
    padding: 20,
    borderRadius: 10,
    background: "white",
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    fontFamily: "Arial, sans-serif",
  },
};

export default LoanStatus;
